import { ParticleEffectEnum } from '@/components/particle-effect-item';
import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import useMessageExpireTimer from '@/scripts/hooks/useMessageExpireTimer';

function MessageWithExpireAnimate({
  message,
  chat,
  isMe,
  children,
}: {
  message: ChatMessage;
  chat: Chat;
  isMe: boolean;
  children: React.ReactNode | ((displayTime: string) => React.ReactNode);
}) {
  const duration = ParticleEffectEnum.Duration;
  const [hidden, setHidden] = useState(false);
  const { displayTime } = useMessageExpireTimer({
    message: message!,
    chat,
    doExpireAnimation: () => {
      return new Promise((resolve) => {
        setHidden(true);
        const timerId = setTimeout(() => {
          resolve(duration);
          clearTimeout(timerId);
        }, duration);
      });
    },
  });

  return (
    <ParticleEffectItem
      hidden={hidden}
      duration={duration}
      // color={isMe ? 'rgba(112, 62, 255, 0.1)' : '#fff'}
      color="#ccc"
      type="rectangle"
      style="fill"
      direction={isMe ? 'left' : 'right'}
    >
      {typeof children === 'function' ? children(displayTime) : children}
    </ParticleEffectItem>
  );
}

export default memo(MessageWithExpireAnimate);
